import { render, staticRenderFns } from "./EstrangeiroEntradaBrasil.vue?vue&type=template&id=778b26e0&"
import script from "./EstrangeiroEntradaBrasil.vue?vue&type=script&lang=js&"
export * from "./EstrangeiroEntradaBrasil.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports